import React from "react";

/**
 * Simple circular AI score dial (SVG-only, no library).
 * Threshold colors match the OpportunityBadge palette.
 */
export default function AIScoreDial({ score = 0, size = 128, stroke = 10 }) {
  const s = Math.max(0, Math.min(100, score || 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = c * (s / 100);

  let color = "#EF4444";
  let label = "high_risk";
  if (s >= 85) { color = "#10B981"; label = "strong_buy"; }
  else if (s >= 70) { color = "#F59E0B"; label = "good"; }
  else if (s >= 50) { color = "#F97316"; label = "neutral"; }

  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid={`ai-score-dial-${label}`}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#F1F5F9"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 500ms ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-[10px] uppercase tracking-[0.16em] text-slate-400 font-semibold">
          AI Score
        </div>
        <div
          className="font-heading font-bold tracking-tight tabular-nums leading-none mt-0.5"
          style={{ color, fontSize: size / 3.4 }}
        >
          {s.toFixed(0)}
        </div>
        <div className="text-[10px] text-slate-400 mt-0.5">/ 100</div>
      </div>
    </div>
  );
}
